import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardKepalaSkb } from 'app/KinerjaPamongPage/components/PageGuardKepalaSkb'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'
import { Homepage } from 'app/KinerjaPamongPage/pages/pejabat-penilai-kinerja/Homepage'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaPamongPegawaiIndex = () => {
  return (
    <PageGuardKepalaSkb>
      <KinerjaTipeProvider tipe="SPNF">
        <Homepage />
      </KinerjaTipeProvider>
    </PageGuardKepalaSkb>
  )
}

KinerjaPamongPegawaiIndex.Layout = KinerjaLayout

KinerjaPamongPegawaiIndex.layoutOpts = {
  hasHeader: true,
}

export default KinerjaPamongPegawaiIndex
